import { createContext, useEffect, useState } from "react";

// Platforms
import { Api } from "../platforms/api";

// Utils
import { reformatAcfResponse } from "../utils/fetchUtils";

export const ConferencesContext = createContext({});

export const ConferencesProvider = (props) => {
    const { children } = props;

    /************************************************
     * useState
     ************************************************/

    const [conferences, setConferences] = useState([]);
    const [featuredConference, setFeaturedConference] = useState(null);
    const [isLoadingConferences, setIsLoadingConferences] = useState(true);

    /************************************************
     * useEffect
     ************************************************/

    useEffect(() => {
        if (conferences?.length) {
            handleSetFeaturedConference();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conferences]);

    /************************************************
     * End Hooks
     ************************************************/

    function fetchConferences() {
        Api.getConferences(onFetchConferencesSuccess);
    }

    function handleSetFeaturedConference() {
        setFeaturedConference(
            conferences.find((conference) => conference.is_featured)
        );
    }

    function onFetchConferencesSuccess({ headers, body: res }) {
        setConferences(reformatAcfResponse(res));
        setIsLoadingConferences(false);
    }

    const conferencesContext = {
        conferences,
        featuredConference,
        fetchConferences,
        isLoadingConferences,
    };

    return (
        <ConferencesContext.Provider value={conferencesContext}>
            {children}
        </ConferencesContext.Provider>
    );
};
